import { GlobalSearchComponent } from "../search/global-search.component"
import templateHTML from './global-search-opener.component.html?raw'
import styles from "../search/global-search.scss?inline"
import { i18n } from "../../../internationalize/i18n.service"

export class GlobalSearchOpener extends HTMLElement {
  private _searchComponent: GlobalSearchComponent

  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
  }

  async connectedCallback() {
    const templateContainer = document.createElement('div');
    templateContainer.innerHTML = templateHTML;
    const template = templateContainer.querySelector('template');

    if (template) {
      const style = document.createElement('style');
      style.textContent = styles;
      this.shadowRoot?.appendChild(style);
      this.shadowRoot?.appendChild(template.content.cloneNode(true));
      this.shadowRoot?.querySelectorAll<HTMLElement>('[i18n]').forEach((elem) => {
        const key = elem.getAttribute('i18n');
        if (key) {
          elem.innerText = i18n.t(key);
        }
      });
    }

    this._searchComponent = document.createElement('tbw-global-search') as GlobalSearchComponent
    document.body.appendChild(this._searchComponent)
    this.shadowRoot.addEventListener('click', (_) => {
      if (this._searchComponent.close) this._searchComponent.show()
    })
    document.addEventListener("keydown", (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'k') {
        if (this._searchComponent.close) this._searchComponent.show()
      }
    })
  }
}
